const TITLES = {
  APP_NAME: 'Agro Servicios El Esfuerzo',
  NIT_BILL: '46836667',
  ADDRESS_BILL: '06 calle Zona 2 San Juan La Laguna',
  ListProduct: '',
  CreateProduct: '',
  UpdateProduct: '',
}

const BUTTONS = {
  ListProduct: '',
  CreateProduct: '',
  UpdateProduct: '',
}

export {
  TITLES,
  BUTTONS,
}